import { redirect } from "react-router-dom";
import { isLoggedIn } from "./getToken";

export function checkAuthLoader() {
  if (!isLoggedIn()) return redirect("/login");
  return null;
}
